<template>
  <div class="layout">
    <div class="head">
      <slot name="head"></slot>
    </div>
    <div class="main">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  @apply bg-white;
  color: var(--resume-font-color);
  font-family: var(--resume-font-family);
  line-height: var(--resume-line-height);
  padding-top: calc(var(--resume-margin) / 2);
  padding-bottom: var(--resume-margin);
  :deep(h1),
  :deep(h2),
  :deep(h3) {
    @apply font-bold;
    color: var(--resume-primary-color);
    font-family: var(--resume-font-family);
  }
  .sidebar,
  .main,
  .head {
    grid-area: sidebar;
    @apply bg-transparent;
  }
  .head {
    background-color: var(--resume-background-color);
    margin: 0 calc(var(--resume-margin) / 2);
    @apply p-8-em;
  }
  .main {
    padding: var(--resume-margin);
  }

  .sidebar,
  .main {
    @apply pt-2-em;
  }
  .sidebar {
    background-color: var(--resume-background-color);
  }
}
</style>
